import React from "react";
import Icon, { IconProps } from "./Icon";

// Sort/sliders icon used in Search sort dropdown.
const SortIcon: React.FC<IconProps> = ({
  size = 24,
  color = "#343B91",
  ...props
}) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 24 24" {...props}>
      <path
        d="M4 7H20"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M4 12H16"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M4 17H20"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7Z"
        stroke={color}
        strokeWidth="1.8"
      />
      <path
        d="M18 17C18 18.1046 17.1046 19 16 19C14.8954 19 14 18.1046 14 17C14 15.8954 14.8954 15 16 15C17.1046 15 18 15.8954 18 17Z"
        stroke={color}
        strokeWidth="1.8"
      />
    </Icon>
  );
};

export default SortIcon;


